export const ConfigBeacons = () => {
    return (
        <div>
            <h1>Beacons Configuration</h1>
        </div>
    )
}